import React from 'react';
import './NavLinkDropdown.scss';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const getLinksStyle = (colOne, colTwo) => {
  if (colOne && colTwo) {
    return { gridTemplateColumns: '1fr 1fr', width: '40%' };
  }

  if (colOne) {
    return { gridTemplateColumns: '1fr', width: '20%' };
  }

  return { display: 'none' };
};

const getContentStyle = (colOne, colTwo) => {
  if (colOne && colTwo) {
    return { width: '60%' };
  }

  if (colOne) {
    return { width: '80%' };
  }

  return { width: '60%' };
};

const NavLinkDropdown = props => {
  const { nav, hoveredItem, index, handleMouseLeave } = props;
  const cards = nav?.cards;
  const colOne = nav?.colOne;
  const colTwo = nav?.colTwo;

  if (cards && Array.isArray(cards) && cards.length > 0) {
    return (
      <div
        className={`odNavLinkDropdown ${
          nav.hasChild && hoveredItem === index && 'odNavLinkDropdown__open'
        }`}
        onMouseLeave={handleMouseLeave}
      >
        <div className="odNavLinkDropdown__container">
          <div className="odNavLinkDropdown__links" style={{ ...getLinksStyle(colOne, colTwo) }}>
            {colOne && colOne?.length > 0 ? (
              <div className="odNavLinkDropdown__colOne">
                {colOne.map(link => (
                  <a
                    key={link.title}
                    className="od_link odNavLinkDropdown__colLink"
                    href={link.link}
                    style={link?.marginBottom ? { marginBottom: link.marginBottom } : {}}
                    onClick={() => triggerDataLayerOnCtaClick(link.title)}
                  >
                    {link?.img ? (
                      <img
                        alt={link?.img?.alt}
                        className="odNavLinkDropdown__colLinkImg"
                        src={link?.img?.src}
                      />
                    ) : null}{' '}
                    {link?.title}
                  </a>
                ))}
              </div>
            ) : null}
            {colTwo && colTwo?.length > 0 ? (
              <div className="odNavLinkDropdown__colTwo">
                {colTwo.map(link => (
                  <a
                    key={link.title}
                    className="od_link odNavLinkDropdown__colLink"
                    href={link.link}
                    style={link?.marginBottom ? { marginBottom: link.marginBottom } : {}}
                    onClick={() => triggerDataLayerOnCtaClick(link.title)}
                  >
                    {link?.img ? (
                      <img
                        alt={link?.img?.alt}
                        className="odNavLinkDropdown__colLinkImg"
                        src={link?.img?.src}
                      />
                    ) : null}
                    {link?.title}
                  </a>
                ))}
              </div>
            ) : null}
          </div>
          <div
            className="odNavLinkDropdown__content"
            style={{ gridTemplateColumns: nav?.cardsGrid, ...getContentStyle(colOne, colTwo) }}
          >
            {cards.map(link => (
              <a
                key={link?.title}
                className="odNavLinkDropdown__card od_link"
                href={link?.link}
                onClick={() => triggerDataLayerOnCtaClick(link.title)}
              >
                <img alt={link.title} className="odNavLinkDropdown__img" src={link?.src} />
                <div className="odNavLinkDropdown__label">{link.title}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default NavLinkDropdown;
